import sound from 'assets/sound/sonido_alerta.mp3';
import { useEffect, useRef } from 'react';
import { ButtonClose } from '../Button-close/Button-close';
import './Alert.scss';

interface IPropsAlert {
  type: 'successful' | 'error' | 'warning';
  title: string;
  message: string;
  onClick?: () => void;
}

export const Alert = (props: IPropsAlert) => {
  const audioRef = useRef(new Audio(sound));

  useEffect(() => {
    const playSound = () => {
      if (audioRef.current.paused) {
        audioRef.current
          .play()
          .catch((err) => console.error('Error al reproducir sonido:', err));
      }
    };

    if (document.visibilityState === 'visible') {
      playSound();
    } else {
      document.addEventListener('click', playSound, { once: true });
    }

    return () => {
      document.removeEventListener('click', playSound);
    };
  }, []);

  return (
    <div className={`alert__contianer ${props.type ? props.type : ''}`}>
      <div className="alert__content">
        <div className="alert__container__header">
          <span className="alert__title">{props.title}</span>
          <ButtonClose onClick={props.onClick} />
        </div>
        <p
          className="alert__text"
          dangerouslySetInnerHTML={{ __html: props.message }}
        ></p>
      </div>
      <div className="alert__bar">
        <div className="alert__bar__progress"></div>
      </div>
    </div>
  );
};
